import moment from "moment";

export function formatDatetimeToMSQL(date) {
  if (!date) return "";
  if (!moment(date).isValid()) return "";
  return moment(date).format("YYYY-MM-DD HH:mm:ss");
}

export function localizeDate(date) {
  if (!date || !moment(date).isValid()) return "-";
  const userLocale = navigator.language || "en-US";
  const localDate = new Date(date);

  const formatted = new Intl.DateTimeFormat(userLocale, {
    dateStyle: "short",
    timeStyle: "short",
    hour12: true,
  }).format(localDate);
  return formatted.replace(/\b(am|pm)\b/, (match) => match.toUpperCase());
}
